import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouWillLearn() {
  const checklist = ['Cómo funciona el sistema', 'Qué derechos tienes como consumidor', 'Cómo interpretar mejor tu situación', 'Aspectos legales importantes', 'Herramientas educativas prácticas', 'Cómo tomar decisiones más informadas'];
  return <section className="py-16 md:py-24 px-4 bg-brand-green text-white relative overflow-hidden" data-id="element-371">
      <div className="absolute inset-0 bg-radial-green opacity-50" data-id="element-372" />

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-373">
        <div className="md:w-1/2" data-id="element-374">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black mb-6 leading-tight" data-id="element-375">
            Lo que descubrirás dentro del MegaPack
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-white/90 mb-8" data-id="element-376">
            Información clara, directa y adaptada a la realidad uruguaya para
            que retomes el control.
          </motion.p>
        </div>

        <div className="md:w-1/2 w-full" data-id="element-377">
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-378">
            <ul className="space-y-4" data-id="element-379">
              {checklist.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-3" data-id="element-380">
                  <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-381" />
                  <span className="text-slate-dark font-medium text-lg" data-id="element-382">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}